export default __webpack_public_path__ + "static/mh-0-25-6142cb97f98987d1f8f65966abbe740d.jpg";